import React from "react";
import Chart from "react-apexcharts";
import ApexCharts from "apexcharts";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import {
  FaChartLine,
  FaDownload,
  FaGamepad,
  FaGlobeEurope,
} from "react-icons/fa";
import { BiSolidDonateBlood } from "react-icons/bi";
import { MdOpenInNew } from "react-icons/md";
import ReactApexChart from "react-apexcharts";

const AdViewCompletionChart = ({ adViewCompletionData }) => {
  return (
    <div className="box shadow p-4 rounded cardBox text-light w-100 d-flex flex-column">
      <div className="card-body">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
          <h5 className="card-title mb-3 mb-md-0">
            Ad View Completion (%) Per Game
          </h5>
          <div className="d-flex align-items-center">
            <a
              href="/ad-view-count"
              className="text-decoration-none text-light me-2 d-flex align-items-center gap-2"
            >
              View All
              <MdOpenInNew className="fs-5" />
            </a>
          </div>
        </div>

        {adViewCompletionData?.length > 0 ? (
          <Chart
            options={{
              chart: {
                type: "bar",
                toolbar: { show: false },
              },
              plotOptions: {
                bar: {
                  horizontal: true,
                  barHeight: "60%",
                  borderRadius: 6,
                },
              },
              dataLabels: {
                enabled: true,
                formatter: function (val) {
                  return val + "%";
                },
                style: {
                  colors: ["#fff"],
                },
              },
              xaxis: {
                categories:
                  adViewCompletionData?.map((item) => item.game_title) || [],
                // categories: [
                //   "Game 1",
                //   "Game 2",
                //   "Game 3",
                //   "Game 4",
                //   "Game 5",
                //   "Game 6",
                // ],
                labels: {
                  style: { colors: "#fff" },
                },
              },
              yaxis: {
                labels: {
                  style: { colors: "#fff" },
                },
              },
              tooltip: {
                theme: "dark",
              },
              colors: ["#00e396"],
            }}
            series={[
              {
                name: "% Viewed",
                data: adViewCompletionData?.map((item) =>
                  item.total_ads > 0 && item.watched_ads > 0
                    ? ((item.watched_ads / item.total_ads) * 100).toFixed(1)
                    : 0
                ),
              },
              // {
              //   name: "% Viewed",
              //   data: [32, 45, 21, 50, 75, 68],
              // },
            ]}
            type="bar"
            height={400}
          />
        ) : (
          <p className="mt-3 text-center">No data available.</p>
        )}
      </div>
    </div>
  );
};
export default AdViewCompletionChart;
